const EN = 'en';

export { EN };

export const LOCALE_SET_LOCALE = 'LOCALE_SET_LOCALE';
